import { useState, useEffect } from 'react';

// Брейкпоинты для responsive дизайна
export const breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  wide: 1440
};

export type ScreenSize = 'mobile' | 'tablet' | 'desktop' | 'wide';

export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState<ScreenSize>('mobile');
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);

      if (width >= breakpoints.wide) {
        setScreenSize('wide');
      } else if (width >= breakpoints.desktop) {
        setScreenSize('desktop');
      } else if (width >= breakpoints.tablet) {
        setScreenSize('tablet');
      } else {
        setScreenSize('mobile');
      }
    };

    // Установить начальный размер
    handleResize();

    // Слушать изменения размера окна
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    screenSize,
    windowWidth,
    isMobile: screenSize === 'mobile',
    isTablet: screenSize === 'tablet',
    isDesktop: screenSize === 'desktop' || screenSize === 'wide',
    isWide: screenSize === 'wide'
  };
};
